module.exports = __webpack_public_path__ + "z/authentic-mobile.de38148a.jpg";